import React, { Component } from "react";
import { callAPI } from "../../assets/Js/backendCommunication";
import { getPlainToken } from "../../assets/Js/tokenHandler";

import { connect } from "react-redux";

import projectSettings from "../../assets/Js/projectSettings";
import { Spinner } from "../../Components/Spinner/Spinner";
import { immediateToast } from "izitoast-react";
import { Date_Error, Choose_Workout } from "../../assets/Js/errorMessage";
import workoutApiCalled from "../../redux/actionCreators/workoutApiCalled";
import { apiResponseToast } from "../../assets/Js/apiResponseToast";
import { closeModel } from "../../assets/Js/closeModel";

const mapDispatchToProps = (dispatch) => {
  return {
    workOutApiCalled: () => dispatch(workoutApiCalled()),
  };
};

const mapStateToProps = (state) => {
  return {
    trackInfo: state.trackInfo,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class FromDatabase extends Component {
    constructor() {
      super();
      this.state = {
        date: "yyyy/mm/dd",
        data: [],
        activeCheckBox: null,
        isLoading: false,
        isSaveLoading: false,
      };
    }

    componentDidMount() {
      this.getWorkOutFromDatabase();
    }

    getWorkOutFromDatabase = async () => {
      let url = `${projectSettings.baseUrl}/workouts/database`;
      let header = true;
      let type = "GET";
      let token = getPlainToken();
      let data = null;
      let response = "";
      if (response === "") {
        this.setState({ isLoading: true });
      }
      response = await callAPI(url, header, type, data, token);
      this.setState({ isLoading: false });
      if (response) {
        this.setState({ data: response.data });
      }
    };

    handleCheckBox = (index) => {
      this.setState({
        activeCheckBox: this.state.activeCheckBox !== index ? index : null,
      });
    };

    handleSave = () => {
      let data = {};
           
      if (this.state.activeCheckBox === null) {
        immediateToast("warning", {
          message: Choose_Workout,
        });
        return;
      }
      if (this.props.workoutDate === "mm/dd/yyyy") {
        immediateToast("warning", {
          message: Date_Error,
        });
        return;
      }
      let stateData = this.state.data[this.state.activeCheckBox];

      data.Id = stateData.Id;
      data.Description = stateData.Description;
      data.IsPublished = stateData.IsPublished;
      data.Name = stateData.Name;
      data.Notes = stateData.Notes;
      data.videoUrl = stateData.videoUrl;
      data.Sets = stateData.Sets;
      data.WorkoutType = stateData.WorkoutType;
      data.ScoreType = stateData.ScoreType;

      let newFormDate = new Date(this.props.workoutDate);
      data.Schedule = new Date(
        newFormDate.getTime() - newFormDate.getTimezoneOffset() * 60000
      );

      data.TrackId = this.props.trackInfo.Id;
      this.postWorkout(data);
    };

    postWorkout = async (workout) => {
      let url = `${projectSettings.baseUrl}/workouts/create`;
      let header = true;
      let type = "POST";
      let token = getPlainToken();
      let data = null;

      data = workout;
      let response = "";
      if (response === "") {
        this.setState({ isSaveLoading: true });
      }
      response = await callAPI(url, header, type, JSON.stringify(data), token);
      this.setState({ isSaveLoading: false });
      if (response) {
        apiResponseToast(response.status, "addWorkout");
        this.setState({ isLoading: false });
        if (response.type === "error") {
        } else if (response.type === "success") {
          this.props.workOutApiCalled();
          this.props &&
            this.props.resetOnCloseModal &&
            this.props.resetOnCloseModal();

          this.props.closeModal
            ? this.props.closeModal()
            : closeModel(this.props.modalId);
          response = "";
        }
      }
    };

    render() {
      return (
        <div className="container  mx-auto">
          {this.state.isLoading && <Spinner />}
          {this.state.data.length > 0 && (
            <div className="d-flex align-items-center justify-content-end">
              <div className="width-fit-content">
                <button
                  className="basicBtnStyle primaryBtn ml-1"
                  onClick={this.handleSave}
                >
                  <i className="mdi mdi-plus menu-icon colorWhite"></i>
                  <span>Add Workout</span>
                </button>
              </div>
            </div>
          )}

          <div
            className="accordion mt-3 accordionBox overflow-auto primaryScrollBar tertiaryScrollBar"
            id="DBaccordian"
          >
            {this.state.isSaveLoading ? (
              <Spinner />
            ) : this.state.data.length > 0 ? (
              this.state.data.map((currVal, index) => (
                <div className="card" key={index}>
                  <div className="card-header pt-0 pb-0" id={`heading${index}`}>
                    <h2 className="mb-0">
                      <input
                        type="checkbox"
                        className="databaseCheckBox"
                        checked={
                          this.state.activeCheckBox === index ? true : false
                        }
                        onChange={() => {
                          this.handleCheckBox(index);
                        }}
                      />
                      <button
                        className={`btn ${!index ? "collapsed" : null}`}
                        type="button"
                        data-toggle="collapse"
                        data-target={`#collapse${index}`}
                        aria-expanded={!index ? "true" : "false"}
                        aria-controls="collapseOne"
                      >
                        {currVal.Name + " " + (index + 1)}
                      </button>
                    </h2>
                  </div>

                  <div
                    id={`collapse${index}`}
                    className={`collapse ${!index ? "show" : null}`}
                    aria-labelledby={`heading${index}`}
                    data-parent="#DBaccordian"
                  >
                    <div className="card-body">
                      <div className="font-weight-bold">Type:</div>
                      <span>{currVal.WorkoutType}</span>
                      <br />
                      <div className="font-weight-bold mt-2">Description:</div>
                      <span>{currVal.Description}</span>
                      <br />
                      <div className="font-weight-bold mt-2">Video Link:</div>
                      <span>{currVal.videoUrl}</span>
                      <br />
                    </div>
                  </div>
                </div>
              ))
            ) : !this.state.isLoading ? (
              <div className="d-flex justify-content-center  mb-3">
                <span>No workout in database</span>
              </div>
            ) : null}
          </div>
        </div>
      );
    }
  }
);
